export const serverUrl ={
    t:"https://test.alistetechnologies.com:8443",
    u:"https://web.alistetechnologies.com",
    s:"https://int.alistetechnologies.com",
}
